var _defs, _g, _path, _path2, _path3, _polygon, _path4, _path5, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeRoomWidthRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 10.69,
    x2: 225.88,
    y2: 10.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.28,
    x2: 216.07,
    y2: 65.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5999.04,
    y1: -2657.91,
    x2: -5963.5,
    y2: -2657.91,
    gradientTransform: "translate(-5963.34 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 5.9 199.96 18.58 190.25 12.68 190.41 0 200.12 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0 225.88 0.36 225.76 21.37 213.19 13.79 202.9 7.58 190.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 21.37 225.8 34.06 215.91 28.16 216.07 15.48 225.76 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 5.9 216.07 15.48 26.94 124.67 11.01 115.09 200.14 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 15.48 215.91 28.16 27.5 137.36 26.94 124.67 216.07 15.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 129.97 35.7 142.96 0 142.3 0.16 129.62 35.7 129.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 129.97 0.16 129.62 0.27 108.6 12.85 116.18 23.13 122.39 35.7 129.97"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.52,73.57l2.73,4.34v.14l-2.78,1.6-2.36-3.93-2.06,1.19V82.2l-2.59,1.49,0-14.43,4.66-2.69c1.49-.86,2.64-1.14,3.44-.85s1.22,1.14,1.22,2.52A7,7,0,0,1,55.2,71,9,9,0,0,1,53.52,73.57Zm-.89-1.71A3.44,3.44,0,0,0,53.16,70q0-1-.51-1.32c-.33-.19-.85-.09-1.55.31L49,70.17v4.34l2.09-1.21a4.07,4.07,0,0,0,1.5-1.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.72,59.28,68.46,71l-2.75,1.59-.88-2.47-4.54,2.62-.85,3.47-2.76,1.58,4.64-17.12ZM61,69.92l3.14-1.81-1.59-4.49L61,69.92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.94,50.49,79,60a8.38,8.38,0,0,1-1.28,4.48,9.65,9.65,0,0,1-3.51,3.41c-1.47.85-2.63,1.07-3.5.69s-1.31-1.37-1.33-2.93l0-9.61,2.59-1.49,0,9.52c0,1,.2,1.52.6,1.73s.94.1,1.63-.3a4.27,4.27,0,0,0,2.21-3.91l0-9.61Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "94.28 41.63 94.32 56.06 91.73 57.56 91.72 53.61 91.95 46.66 88.59 59.37 86.82 60.4 83.41 51.61 83.69 58.25 83.7 62.2 81.11 63.69 81.07 49.26 84.45 47.31 87.71 55.91 90.88 43.59 94.28 41.63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.34,43.39a2.3,2.3,0,0,1,.56,1.74,6.61,6.61,0,0,1-1.14,3.81,9.8,9.8,0,0,1-3.29,3l-4.89,2.82,0-14.43,4.4-2.54c1.53-.88,2.68-1.21,3.47-1s1.19,1,1.19,2.27a5.24,5.24,0,0,1-.47,2.14,6.33,6.33,0,0,1-1.31,1.94A1.49,1.49,0,0,1,105.34,43.39Zm-2.53,4.88a3.06,3.06,0,0,0,.51-1.68c0-1.32-.6-1.65-1.8-1L99.16,47v3.89l2.21-1.28a4.06,4.06,0,0,0,1.43-1.32m-3.67-7v3.64l1.92-1.11A3.35,3.35,0,0,0,103,40.85c0-.66-.16-1-.49-1.13a2.33,2.33,0,0,0-1.57.48l-1.81,1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.91,38.13l2.73,4.33v.14l-2.78,1.61-2.37-3.93-2.06,1.19v5.29l-2.58,1.49,0-14.43,4.66-2.7c1.48-.85,2.64-1.13,3.44-.84s1.21,1.14,1.22,2.52a7.05,7.05,0,0,1-.55,2.79A9.24,9.24,0,0,1,114.91,38.13ZM114,36.42a3.52,3.52,0,0,0,.53-1.88c0-.68-.17-1.12-.51-1.31s-.85-.1-1.55.3l-2.08,1.2v4.34l2.09-1.21A4.19,4.19,0,0,0,114,36.42"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "127.49 22.46 127.5 24.86 121.68 28.22 121.69 31.66 126.66 28.8 126.67 31.11 121.7 33.97 121.71 37.85 127.54 34.49 127.55 36.88 119.13 41.74 119.09 27.31 127.49 22.46"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "131.78 19.98 131.82 34.41 129.23 35.91 129.19 21.48 131.78 19.98"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "143.38 13.29 143.39 15.69 139.54 17.91 139.58 29.94 136.98 31.43 136.95 19.41 133.16 21.6 133.15 19.19 143.38 13.29"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "153.26 7.58 153.26 9.99 147.45 13.35 147.46 16.79 152.42 13.92 152.43 16.23 147.46 19.1 147.47 22.98 153.31 19.61 153.32 22 144.9 26.87 144.85 12.44 153.26 7.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeRoomWidthRed);
export default __webpack_public_path__ + "static/media/de-room-width-red.e0cb6a7bb03353135f5a172631228b16.svg";
export { ForwardRef as ReactComponent };